/**
 * Jack & Jones — design band anchors that change with the viewport.
 *
 * Some bands of the Figma are cut differently on desktop and mobile (the PLP toolbar and grid are
 * «content-04» + «content-05» on desktop and a single «listado» on mobile). Those elements carry
 * data-section-desktop / data-section-mobile and this script copies the right one into
 * data-section, which is what the per-section diff pairs by name. Bands that are the same on both
 * viewports write data-section straight in the Liquid.
 *
 * A filter or sort update morphs the section and drops the attribute, so it is applied again then.
 */
import { StandardEvents } from '@shopify/events';

const mobileQuery = window.matchMedia('(max-width: 749px)');

function applyAnchors() {
  const key = mobileQuery.matches ? 'sectionMobile' : 'sectionDesktop';
  document.querySelectorAll('[data-section-desktop], [data-section-mobile]').forEach((element) => {
    if (!(element instanceof HTMLElement)) return;
    const name = element.dataset[key];
    if (name) element.setAttribute('data-section', name);
    else element.removeAttribute('data-section');
  });
}

/** @param {Event} event */
function onCollectionUpdate(event) {
  const promise = /** @type {{ promise?: Promise<unknown> }} */ (event).promise;
  if (promise && typeof promise.finally === 'function') {
    promise.finally(applyAnchors);
    return;
  }
  // Without a promise: on the first change of the page after the event (5s at most)
  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    observer.disconnect();
    requestAnimationFrame(applyAnchors);
  };
  const observer = new MutationObserver(finish);
  observer.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  window.setTimeout(finish, 5000);
}

if (!window.jjSectionAnchorsReady) {
  window.jjSectionAnchorsReady = true;
  applyAnchors();
  mobileQuery.addEventListener('change', applyAnchors);
  document.addEventListener('shopify:section:load', applyAnchors);
  document.addEventListener(StandardEvents.collectionUpdate, onCollectionUpdate);
}
